import apiClient from './apiClient';

const baseUrl = process.env.REACT_APP_AUTH_URL;

class OAuthService {
  // Google OAuth Login
  async loginWithGoogle(googleToken) {
    try {
      const response = await apiClient.post(`${baseUrl}/user/oauth/google`, {
        token: googleToken
      });
      return response.data;
    } catch (error) {
      console.error('Google OAuth login error:', error);
      throw error;
    }
  }

  // Apple OAuth Login
  async loginWithApple(appleToken) {
    try {
      const response = await apiClient.post(`${baseUrl}/user/oauth/apple`, {
        token: appleToken
      });
      return response.data;
    } catch (error) {
      console.error('Apple OAuth login error:', error);
      throw error;
    }
  }

  // Generic OAuth login
  async oauthLogin(token, provider) {
    try {
      const response = await apiClient.post(`${baseUrl}/user/oauth/login`, {
        token,
        provider
      });
      return response.data;
    } catch (error) {
      console.error(`${provider} OAuth login error:`, error);
      throw error;
    }
  }
}

export default new OAuthService();


